import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
const CacheSessionTable = ({ data, editBtnClick }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  return (
    <TableContainer
      className="tableairp-responsive"
      style={{ maxHeight: "none", height: "100%", marginTop: "20px" }}
    >
      <Table className="table-airp">
        <TableHead>
          <TableRow className="laststick-tr">
            {TableHeaderName.map((item, index) => (
              <TableCell key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((item, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.DestinationCode}</TableCell>
                <TableCell>{item.sessionTime}</TableCell>
                {/* <TableCell>{item.daysRange}</TableCell> */}
                <TableCell>{item.suppId}</TableCell>
                <TableCell>{item.daysRangeFrom}</TableCell>
                <TableCell>{item.daysRangeTo}</TableCell>
                <TableCell>
                  <div className="d-flex">
                    <div className="me-2">
                      <IconButton
                        aria-label="edit"
                        color="success"
                        onClick={() => editBtnClick(item)}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, page) => setPage(page)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(+e.target.value);
          setPage(0);
        }}
      />
    </TableContainer>
  );
};

export default CacheSessionTable;
const TableHeaderName = [
  "S.No.",
  "Destination Code",
  "Session Time",
  // "Days Range",
  "Supplier Id",
  "Days Range From",
  "Days Range To",
  "Edit",
];
